// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"440":"747be575964ba52e","754":"d2871a083f6e0c69"}[chunkId] + ".css";
};